import { t } from 'i18next';
import * as yup from 'yup';

import { testRequiredSchema } from 'core/schemas';
import { CustomerExternalNumberType } from 'customer/enums';
import { PURCHASE_ORDER_NUMBER_MAX_LENGTH } from 'quotes/constants';
import { OrderType } from 'quotes/enums';

import { shipSelectionSchema } from '../CustomerQuoteUpsert/ShipSelectionDateFields/schema';

export const quotePartCreateOrderSchema = (required = false, isAlternateVersionEnabled = false) =>
  yup.object().shape(quotePartCreateOrderSchemaFields(required, isAlternateVersionEnabled));

export const quotePartCreateOrderSchemaFields = (
  required = false,
  isAlternateVersionEnabled = false,
  isEdit = false
) => ({
  ...(!isAlternateVersionEnabled && {
    customerNumber: yup
      .object()
      .shape({
        externalCustomerNumber: externalCustomerNumberSchema(required, isAlternateVersionEnabled),
        label: yup.string().nullable(),
        source: yup.string().nullable(),
      })
      .label(t('labelCustomerNumber'))
      .nullable()
      .test(...testRequiredSchema(required, t('labelCustomerNumber'))),
    customerNumberType: yup
      .string()
      .oneOf([null, ...Object.values(CustomerExternalNumberType)])
      .label(t('labelCustomerNumberType'))
      .nullable(),
  }),
  ...(isAlternateVersionEnabled && {
    billToLocation: yup
      .object()
      .shape({
        id: yup
          .string()
          .label(t('labelBillToLocation'))
          .nullable()
          .test(...testRequiredSchema(required && !isEdit, t('labelBillToLocation'))),
      })
      .nullable()
      .test(...testRequiredSchema(required && !isEdit, t('labelBillToLocation'))),
    shipToLocation: yup
      .object()
      .shape({
        id: yup.string().label(t('labelShipToLocation')).nullable(),
      })
      .nullable()
      .test(...testRequiredSchema(required && !isEdit, t('labelShipToLocation'))),
  }),
  purchaseOrderNumber: yup
    .string()
    .label(t('labelPurchaseOrderNumber'))
    .nullable()
    .max(
      PURCHASE_ORDER_NUMBER_MAX_LENGTH,
      t('errorPurchaseOrderNumberTooLong', { max: PURCHASE_ORDER_NUMBER_MAX_LENGTH })
    )
    .test(...testRequiredSchema(required, t('labelPurchaseOrderNumber'))),
  ...(isAlternateVersionEnabled
    ? {
        orderType: yup
          .string()
          .label(t('labelOrderType'))
          .nullable()
          .oneOf(Object.values(OrderType))
          .test(...testRequiredSchema(required, t('labelOrderType'))),
        ...shipSelectionSchema(required),
        shippingMethod: yup
          .object()
          .shape({
            id: yup
              .string()
              .label(t('labelShippingMethod'))
              .nullable()
              .test(...testRequiredSchema(required, t('labelShippingMethod'))),
            name: yup.string().label(t('labelShippingMethod')).nullable(),
          })
          .nullable()
          .test(...testRequiredSchema(required, t('labelShippingMethod'))),
        freightTerm: yup
          .object()
          .shape({
            id: yup
              .string()
              .label(t('labelFreightTerm'))
              .nullable()
              .test(...testRequiredSchema(required, t('labelFreightTerm'))),
            name: yup.string().label(t('labelFreightTerm')).nullable(),
          })
          .nullable()
          .test(...testRequiredSchema(required, t('labelFreightTerm'))),
      }
    : {}),
});

export const externalCustomerNumberSchema = (
  required = false,
  isAlternateVersionEnabled = false
) => {
  const fieldSchema = yup
    .string()
    .label(t('labelCustomerNumber'))
    .nullable()
    .test(...testRequiredSchema(required, t('labelCustomerNumber')));

  if (isAlternateVersionEnabled) {
    return fieldSchema;
  }

  return fieldSchema.nullable().matches(/^\d{6}$/, t('errorCustomerNumberDigitsOnly'));
};
